// assets/tattoo_products.js - 纹身产品数据集合
window.allTattooProducts = [
    {
        "category": "wtk286",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71ejLHx4bNL._SL1500.jpg?v=1747313559",
        "name": "Wormhole Tattoo Gun Kit Wireless Tattoo Machine",
        "description": "Kit Complete Tattoo Kit Tattoo Pen Kit Rechargeable Cordless Tattoo Power Supply Portable 1,800mAh with LED Digital Display for Tattoo Artist WTK286",
        "price": 9.99,
        "originalPrice": 37.99,
        "rating": 4.5,
        "reviewCount": 219,
        "discountType": "74% off",
        "discountCode": "RXR6MYXP",
        "link": "https://950ife-pn.myshopify.com/pages/wtk286-%E5%B7%B2%E5%AE%8C%E6%88%90"
    },
    {
        "category": "wtk293",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71Bbr22LM2L._SL1500.jpg?v=1747311182",
        "name": "Wormhole Tattoo Gun Tattoo Kit Wireless Tattoo Machine",
        "description": "2PCS 1,200mAh Capaticy Tattoo Batteries, 20 Cartridge Needles with Finger Ledge, Ink Color Set for Artists-Purple",
        "price": 9.99,
        "originalPrice": 47.99,
        "rating": 4.5,
        "reviewCount": 27,
        "discountType": "80% off",
        "discountCode": "9GYKHN3Q",
        "link": "https://ondeals.today/pages/wtk293"
    },
    {
        "category": "wtk283",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81YkFZ4LVpL._SL1500.jpg?v=1747314364",
        "name": "Wormhole Tattoo Gun Kit Wireless Tattoo Machine Kit",
        "description": "Cordless Tattoo Pen Kit Pen-type Tattoo Machine Kit Complete with Tattoo Ink for Tattoo Artist Beginners WTK283",
        "price": 50.39,
        "originalPrice": 55.99,
        "rating": 4.4,
        "reviewCount": 5991,
        "discountType": "10% off",
        "discountCode": "SNKPZVTF",
        "link": "https://950ife-pn.myshopify.com/pages/wtk283-%E5%B7%B2%E5%AE%8C%E6%88%90"
    },
    {
        "category": "wtk090",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81P7GK0VCbL._SL1500.jpg?v=1747311317",
        "name": "Wormhole Tattoo Kit Tattoo Gun Kit",
        "description": "Tattoo Machine Kit for Beginners Tattoo Gun 20 Color Inks Power Supply Tattoo Pen Kit Red",
        "price": 35.89,
        "originalPrice": 39.89,
        "rating": 4.4,
        "reviewCount": 2932,
        "discountType": "3$ off",
        "link": "https://950ife-pn.myshopify.com/pages/wtk090-1"
    },
    {
        "category": "wtk294",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71T3tnjloCL._SL1500.jpg?v=1747813097",
        "name": "Wormhole Tattoo Kit Tattoo Gun Kit",
        "description": "78PCS Wireless Tattoo Gun Kit with 1,500 mAh Capacity Battery, Tattoo Cartridge Needles with Finger Ledge, Complete Tattoo Kit for Beginners and Tattoo Artists WTK294- Black",
        "price": 34.19,
        "originalPrice": 35.99,
        "rating": 4.5,
        "reviewCount": 219,
        "discountType": "5% off",
        "link": "https://950ife-pn.myshopify.com/pages/wtk294"
    },
    {
        "category": "mht-m5-a",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71SAblY5w1L._AC_SL1500.jpg?v=1747303161",
        "name": "Wormhole Tattoo Stencil Printer",
        "description": "Mini Thermal Tattoo Printer, Bluetooth Tattoo Machines Compatible with Tablet, Smartphone for Tattoo Beginners and Artists-Black",
        "price": 47.99,
        "originalPrice": 59.99,
        "rating": 2.5,
        "reviewCount": 142,
        "discountType": "$12 off",
        "link": "https://950ife-pn.myshopify.com/pages/mht-m5-a"
    },
    {
        "category": "n202007-us-a",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71pOU434hFL._AC_SL1500_f4ba0dca-c2ff-4c1b-9c1c-3e25b3e0177f.jpg?v=1747813209",
        "name": "Wormhole Tattoo Stencil Printer",
        "description": "Wireless Bluetooth 2,500mAh Battery Portable Tattoo Printer Compatible with Phone & PC for Artists and Beginners - Dark Gray",
        "price": 63.99,
        "originalPrice": 89.99,
        "rating": 3.8,
        "reviewCount": 194,
        "discountType": "$26 off",
        "link": "https://950ife-pn.myshopify.com/pages/n202007-us-a"
    },
    {
        "category": "wtk277",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81ZVNWJeu9L._SL1500.jpg?v=1747312698",
        "name": "Tattoo Gun Kit",
        "description": "Wormhole Tattoo Kit Wireless Tattoo Machine Kit with Digital Led Display 1,800 mAh Tattoo Power Supply Tattoo Pen Tattoo Cartridge Needles WTK277",
        "price": 19.99,
        "originalPrice": 39.99,
        "rating": 4.5,
        "reviewCount": 151,
        "discountType": "50% off",
        "discountCode": "OJOEDMKA",
        "link": "https://950ife-pn.myshopify.com/pages/wtk277-%E5%B7%B2%E5%AE%8C%E6%88%90"
    },
    {
        "category": "wtk280-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71hKAsIrXWL._SL1500.jpg?v=1747313165",
        "name": "Tattoo Gun Kit",
        "description": "Tattoo Kit Wireless Tattoo Machine Kit 1,600 MAH Battery Tattoo Pen with Digital Led Display Type-C Charged Tattoo Supplies for Beginners WTK280",
        "price": 17.49,
        "originalPrice": 34.99,
        "rating": 4.6,
        "reviewCount": 38,
        "discountType": "50% off",
        "discountCode": "HP83HH9N",
        "link": "https://950ife-pn.myshopify.com/pages/wtk280-us-%E5%B7%B2%E5%AE%8C%E6%88%90"
    },
    {
        "category": "n202007-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71Lu-KksGJL._SL1500.jpg?v=1747309096",
        "name": "Wormhole Tattoo Stencil Printer",
        "description": "Wireless Bluetooth Tattoo Printer with 2500mAh Battery, Portable Tattoo Thermal Copier Machine Compatible with Smartphones & PC N202007",
        "price": 63.99,
        "originalPrice": 79.99,
        "rating": 4.0,
        "reviewCount": 384,
        "discountType": "$16 off",
        "link": "https://950ife-pn.myshopify.com/pages/n202007-us"
    },
    {
        "category": "b0dpqzxdtm",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71w3a1gMrDL._SL1500.jpg?v=1747301886",
        "name": "Wormhole Tattoo 200Pcs Plastic",
        "description": "Tattoo Machine Covers, 3Pcs Tattoo Grip Tape, Disposable Tattoo Pen Covers for Tattoo Artists 65 * 180mm - Blue",
        "price": 8.99,
        "originalPrice": 9.99,
        "rating": 4.7,
        "reviewCount": 72,
        "discountType": "1% off",
        "link": "https://950ife-pn.myshopify.com/pages/b0dpqzxdtm"
    },
    {
        "category": "wtk104",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/817-MKe_QYL._SL1500.jpg?v=1747813516",
        "name": "Wormhole Tattoo Machine Kit",
        "description": "Tattoo Gun Kit Cartridge Needles Tattoo Pen Kit for Beginners Rotary Tattoo Machine Pen Kit Tattoo Supplies WTK104",
        "price": 33.24,
        "originalPrice": 34.99,
        "rating": 4.4,
        "reviewCount": 2600,
        "discountType": "5% off",
        "discountCode": "3L8JH6DX ",
        "link": "https://950ife-pn.myshopify.com/pages/wtk090"
    },
    {
        "category": "wtk302-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71hCYjXfnPL._SL1500.jpg?v=1747307848",
        "name": "Wormhole Tattoo Kit Tattoo Gun Kit",
        "description": "with 1500mAh Battery and 20PCS Disposable Finger Ledge Needles, Complete Tattoo Kit for Beginner and Tattoo Artist - Red WTK302",
        "price": 13.99,
        "originalPrice": 27.99,
        "rating": 4.3,
        "reviewCount": 26,
        "discountType": "50% off ",
        "discountCode": "9IZFQZM9",
        "link": "https://950ife-pn.myshopify.com/pages/wtk302-us"
    },
    {
        "category": "cn-pt6",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71gfZLCmJAL._SL1500.jpg?v=1747302776",
        "name": "Wormhole Tattoo Needles",
        "description": "50pcs Mixed Sizes Disposable Finger Ledge Tattoo Cartridge Needles #12 Standard 3RL 5RL 7RL 9RL 11RL Round Liner for Tattoo Machine Tattoo Gun Tattoo Supplies",
        "price": 9.99,
        "originalPrice": 19.99,
        "rating": 4.6,
        "reviewCount": 100,
        "discountType": "50% off",
        "discountCode": "QG6AYRK4",
        "link": "https://950ife-pn.myshopify.com/pages/cn-pt6"
    },
    {
        "category": "n205001",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/51Hjyd3akPL._SL1500.jpg?v=1747813630",
        "name": "Wormhole Tattoo Arm Rest",
        "description": "Tattoo Chair for client, Tattoo Armrest Stand Tripod, 180° Rotation Adjustable Height and Tilt, Thicken Soft Sponge Pad 8.66*6.69*1.46in, Foldable Arm Rest for Tattoo Artist",
        "price": 31.99,
        "originalPrice": 38.99,
        "rating": 4.5,
        "reviewCount": 35,
        "discountType": "$7 off",
        "link": "https://950ife-pn.myshopify.com/pages/n205001"
    },
    {
        "category": "wtk260",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71s6-e9gYYL._SL1500.jpg?v=1747312417",
        "name": "Wormhole Tattoo Gun Kit",
        "description": "Wireless Tattoo Machine Kit Complete Tattoo Kit Rechargeable Cordless Tattoo Power Supply Portable 1500mAh with LED Digital Display for Beginner and Tattoo Artist WTK260",
        "price": 35.59,
        "originalPrice": 42.59,
        "rating": 4.4,
        "reviewCount": 143,
        "discountType": "$7 off",
        "link": "https://950ife-pn.myshopify.com/pages/wtk260"
    },
    {
        "category": "wtk313-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/6391ace427ade714b70fb966024ae804.jpg?v=1749006718",
        "name": "Wormhole Tattoo ",
        "description": "58Pcs Complete Tattoo Gun Kit - Aluminum Alloy LED Wireless Tattoo Gun with 1800mAh Battery for Tattoo Beginners - Black WTK313",
        "price": 21.99,
        "originalPrice": 43.99,
        "rating": 4.5,
        "reviewCount": 2,
        "discountType": "50% off",
        "discountCode": "RUF582YH",
        "link": "https://ondeals.today/pages/wtk313"
    },
    {
        "category": "wtk258",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71qXU11tdOL._SL1500.jpg?v=1747312139",
        "name": " Wormhole Tattoo Wireless Dot Working",
        "description": "1500mAh Battery Pack Tattoo Gun Kit Professional Tattoo Machine Kit Pen Kit Tattoo Ink Needles WTK258",
        "price": 37.96,
        "originalPrice": 47.96,
        "rating": 4.5,
        "reviewCount": 202,
        "discountType": "10$ off",
        "link": "https://ondeals.today/pages/wtk256"
    },
    {
        "category": "jl-h1-p",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71Mch0FUBKL._SL1500.jpg?v=1749804480",
        "name": " Tattoo Stencil Printer with 10Pcs Transfer Paper",
        "description": "Bluetooth, Wireless, 2000mAh - Portable Thermal Printer Machine for Tattoo Artists - 11.5x2.6x1.8in - Purple",
        "price": 28.99,
        "originalPrice": 57.99,
        "rating": 5.0,
        "reviewCount": 2,
        "discountType": "50% off",
        "discountCode": "T7AQFKEL",
        "link": "https://ondeals.today/pages/padieoe-jl-h1-p"
    },
    {
        "category": "wtk328",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71Xsw_yiGmL._SL1500.jpg?v=1750037861",
        "name": " Wormhole Tattoo Gun 60Pcs",
        "description": "Tattoo Kit Wireless Tattoo Machine with 1300mAh Battery - Complete Tattoo Pen Kit for Beginners Artist - Black WTK328",
        "price": 17.99,
        "originalPrice": 35.99,
        "rating": 5.0,
        "reviewCount": 1,
        "discountType": "50% off ",
        "discountCode": "BBEK43R7",
        "link": "https://ondeals.today/pages/wtk328-us"
    },
    {
        "category": "wtk259-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/68655efe9f1d3bdb0370a8c612fc955a.jpg?v=1750039490",
        "name": " Tattoo Gun Kit",
        "description": "Dotwork Tattoo Kit Wireless Tattoo Machine Kit Rotary Tattoo Gun with 1500mAh Capacity Tattoo Battery Tattoo Power Supply Tattoo Pen Kit for Beginners WTK259",
        "price": 15.49,
        "originalPrice": 30.99,
        "rating": 4.3,
        "reviewCount": 243,
        "discountType": "50% off ",
        "discountCode": "BMEVM7EJ",
        "link": "https://ondeals.today/pages/wormhole-wtk259-us"
    },
    {
        "category": "wtk219-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/74b96dbb2d19db9758ba306fc55ad040.jpg?v=1750040317",
        "name": "  Wormhole Tattoo Kit",
        "description": "Tattoo Kit Wireless Tattoo Machine Kit Rotary Tattoo Gun with 1,050 mAh Capacity Tattoo Power Supply Tattoo Battery Tattoo Pen Kit for Beginners WTK219",
        "price": 16.99,
        "originalPrice": 33.99,
        "rating": 4.5,
        "reviewCount": 488,
        "discountType": "50% off",
        "discountCode": "9DFNLH7G",
        "link": "https://ondeals.today/pages/wormhole-wtk219-us"
    },
    {
        "category": "wtk248",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/68655efe9f1d3bdb0370a8c612fc955a_f689b92b-68cd-4bae-90b1-6507cbe7daa2.jpg?v=1750042021",
        "name": " Wormhole Tattoo Wireless",
        "description": "Tattoo Kit - Complete Rotary Tattoo Machine Kit with 20 Cartridge Needles, Battery Pack, Ink, & Accessories - Adult, Black, Not Water Resistant",
        "price": 22.50,
        "originalPrice": 44.99,
        "rating": 4.5,
        "reviewCount": 37,
        "discountType": "50% off ",
        "discountCode": "WTIENMBV",
        "link": "https://ondeals.today/pages/wtk248"
    },
    {
        "category": "wtk285",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/712e_TWFlDL._SL1500.jpg?v=1750042630",
        "name": " Wormhole Tattoo Gun Kit",
        "description": "Wireless Tattoo Machine Kit with Digital LED Display 1,800 mAh Tattoo Kit Power Supply Tattoo Pen Kit Tattoo Cartridge Needles for Tattoo Artist WTK285",
        "price": 22.50,
        "originalPrice": 44.99,
        "rating": 4.5,
        "reviewCount": 46,
        "discountType": "50% off",
        "discountCode": "WTIENMBV",
        "link": "https://ondeals.today/pages/wormhole-wtk285"
    },
    {
        "category": "cn-pt3-1000-2",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71TNnRmTl4L._SL1500.jpg?v=1750043071",
        "name": "Wormhole Tattoo Cartridge Needles",
        "description": "50pcs Mixed Sizes Disposable Finger Ledge Tattoo Needles #10 Standard 3RL 5RL 7RL 9RL 11RL Round Liner for Tattoo Machine Tattoo Gun Tattoo Supplies",
        "price": 9.99,
        "originalPrice": 19.99,
        "rating": 4.6,
        "reviewCount": 41,
        "discountType": "50% off",
        "discountCode": "OCOXHTQS",
        "link": "https://ondeals.today/pages/cn-pt3-1000-2"
    },
    {
        "category": "h1-g-cd",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71gFOhMIIkL._AC_SL1500.jpg?v=1750044441",
        "name": "Tattoo Stencil Printer",
        "description": "2000mAh Wireless Thermal Tattoo Printer with 10PCS Transfer Paper, Compatible with Phone/Tablet/PC, Portable Thermal Transfer Machine for Tattoo Artists & Beginners",
        "price": 28.99,
        "originalPrice": 57.99,
        "rating": 5.0,
        "reviewCount": 5,
        "discountType": "50% off",
        "discountCode": "T4JXFF5U",
        "link": "https://ondeals.today/pages/h1-g"
    },
    {
        "category": "sl-tk602",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/74b96dbb2d19db9758ba306fc55ad040_60ac1f2b-47e4-4d9b-9b94-527943fa7ad3.jpg?v=1750044951",
        "name": " Wormhole Tattoo Kit",
        "description": "Wormhole Tattoo Pen Kit/Rotary Tattoo Machine Pen for Beginners 10pcs Tattoo Cartridges Needles 5 Tattoo Ink, Professional Complete Tattoo Kit TK602",
        "price": 21.99,
        "originalPrice": 43.99,
        "rating": 4.4,
        "reviewCount": 7061,
        "discountType": "50% off",
        "discountCode": "ODWCA82O",
        "link": "https://ondeals.today/pages/wormhole-sl-tk602"
    },
    {
        "category": "hp67-a-us2",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/74b96dbb2d19db9758ba306fc55ad040_a5c3fe89-421f-4b14-b000-b77dfff8538e.jpg?v=1750045386",
        "name": "Wormhole Tattoo Wireless",
        "description": "LED Digital Display Detachable Tattoo Gun with 2100 mAh Battery for Beginner - Advanced Design Tattoo Machine User-Friendly Tools Tattoo Pen- Gold HP67-A",
        "price": 37.39,
        "originalPrice": 43.99,
        "rating": 4.3,
        "reviewCount": 30,
        "discountType": "15% off",
        "discountCode": "JARAWVLG",
        "link": "https://ondeals.today/pages/wormhole-hp67-a-us2"
    },
    {
        "category": "n201099-s-4k",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/618zJXNlIWL._SL1500.jpg?v=1750053011",
        "name": "3MM Thick Tattoo Practice Skin",
        "description": "4pcs 7.8x7.8in Blank tattoo Fake Skin Silicone Sheet with 2 Templates",
        "price": 11.99,
        "originalPrice": 13.99,
        "rating": 4.0,
        "reviewCount": 53,
        "discountType": "$2 off ",
        "link": "https://ondeals.today/pages/padieoe-n201099-s-4k"
    },
    {
        "category": "n201099-s-6k",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/61-VlbbqQlL._SL1500.jpg?v=1750054132",
        "name": "3MM Thick Tattoo Practice Skin",
        "description": "6pcs 7.8x7.8in Tattoo Fake Skin Blank Double Sides Tattoo Skin Tattoo Practice Sheet Soft Silicone Skin with 2 Tattoo Templates for Tattoo Beginner N201099-S-6K",
        "price": 14.99,
        "originalPrice": 17.99,
        "rating": 4.0,
        "reviewCount": 53,
        "discountType": "$3 off",
        "link": "https://ondeals.today/pages/padieoe-n201099-s-6k"
    },
    {
        "category": "n201099-s-8n",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/515mEB-5-QL._SL1500.jpg?v=1750054732",
        "name": "Tattoo Practice Skin",
        "description": "50pcs Mixed Sizes Disposable Finger Ledge Tattoo Needles #10 Standard 3RL 5RL 7RL 9RL 11RL Round Liner for Tattoo Machine Tattoo Gun Tattoo Supplies",
        "price": 18.99,
        "originalPrice": 22.99,
        "rating": 4.0,
        "reviewCount": 53,
        "discountType": "$4 off ",
        "link": "https://ondeals.today/pages/padieoe-n201099-s-8n"
    },
    {
        "category": "wtk271-us2",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/7149ECGlROL._SL1500.jpg?v=1750056071",
        "name": "Wormhole Tattoo Gun Tattoo Kit",
        "description": "Wireless Tattoo Machine Kit Complete Tattoo Pen Kit with 10 Tattoo Cartridge Needles 5 Ink Tattoo Supplies for Beginner",
        "price": 21.75,
        "originalPrice": 43.50,
        "rating": 3.9,
        "reviewCount": 36,
        "discountType": "50% off",
        "discountCode": "J8LEQGD7",
        "link": "https://ondeals.today/pages/wormhole-wtk271-us2"
    },
    {
        "category": "wtk256",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71uAC4nnGqL._SL1500.jpg?v=1750056980",
        "name": " Wormhole Tattoo Kit",
        "description": "Wormhole Wireless Tattoo Gun Kit Wireless Tattoo Machine Kit with 1,050 mAh Capacity Tattoo Battery Power Supply Wireless Tattoo Pen Kit WTK256",
        "price": 21.50,
        "originalPrice": 42.99,
        "rating": 4.4,
        "reviewCount": 32,
        "discountType": "50% off",
        "discountCode": "38R2J5WX",
        "link": "https://ondeals.today/pages/wormhole-wtk256"
    },
    {
        "category": "wtk279",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71em5KW-BNL._SL1500.jpg?v=1750057881",
        "name": "Tattoo Gun Kit",
        "description": "Wormhole Tattoo Kit Wireless Tattoo Machine Kit with 1,600 mAh Capacity Wireless Power Supply Digital LED Display Tattoo Pen Kit WTK279",
        "price": 17.5,
        "originalPrice": 34.99,
        "rating": 4.4,
        "reviewCount": 62,
        "discountType": "50% off",
        "discountCode": "MW588DN2",
        "link": "https://ondeals.today/pages/wormhole-wtk279"
    },
    {
        "category": "wtk079",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/712PPd53nbL._SL1500.jpg?v=1750058482",
        "name": " Wormhole Tattoo Wireless Tattoo Kit",
        "description": "Complete Rotary Tattoo Machine Kit with 20 Cartridge Needles, Battery Pack, Ink, & Accessories - Adult, Black, Not Water Resistant",
        "price": 17,
        "originalPrice": 33.99,
        "rating": 4.5,
        "reviewCount": 2885,
        "discountType": "50% off",
        "discountCode": "QG28UBU3",
        "link": "https://ondeals.today/pages/wormhole-wtk079"
    },
    {
        "category": "wtk159",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81gwVSzB-DL._SL1500.jpg?v=1750058939",
        "name": "Tattoo Kit Wormhole",
        "description": "Tattoo Rotary Tattoo Machine Kit Complete Tattoo Pen Kit 20PCS Tattoo Cartridge Needles 6PCS Tattoo Ink for Beginners and Tattoo Artists WTK159",
        "price": 30.99,
        "originalPrice": 37.99,
        "rating": 4.5,
        "reviewCount": 136,
        "discountType": "$7 off",
        "link": "https://ondeals.today/pages/wormhole-wtk159"
    },
    {
        "category": "wtk276",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71UD9MhOxYL._SL1500.jpg?v=1750059633",
        "name": "Wireless Tattoo Gun Kit",
        "description": "Wormhole Tattoo Kit Complete Tattoo Gun Kit Wireless Tattoo Machine Kit Rechargeable Cordless Tattoo Power Supply Portable 1500mAh Tattoo Supplies for Tattoo Supplies WTK276",
        "price": 32.99,
        "originalPrice": 37.99,
        "rating": 4.6,
        "reviewCount": 392,
        "discountType": "$5 off",
        "link": "https://ondeals.today/pages/wormhole-wtk276"
    },
    {
        "category": "wtk112",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81Rp_g3QveL._SL1500.jpg?v=1750060523",
        "name": "Wormhole Tattoo Kit",
        "description": "Wireless Tattoo Machine Kit Rotary Tattoo Pen Kit 20PCS Tattoo Cartridge Needles",
        "price": 35.99,
        "originalPrice": 46.99,
        "rating": 4.6,
        "reviewCount": 392,
        "discountType": "23% off",
        "link": "https://xnelbcpfjm2l20n5-93980295457.shopifypreview.com/pages?preview_key=6843014fac0aebfbd9d818ed6b78e428"
    },
    {
        "category": "wtk261",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/716oZ0oHXmL._SL1500.jpg?v=1750060955",
        "name": "Tattoo Gun Kit",
        "description": "Wormhole Wireless Tattoo Machine Kit Tattoo Pen Kit Complete Tattoo Kit Rechargeable Cordless Tattoo Power Supply Portable 1500mAh with LED Digital Display for Tattoo Artist WTK261",
        "price": 35.59,
        "originalPrice": 41.99,
        "rating": 4.3,
        "reviewCount": 30,
        "discountType": "15% off",
        "link": "https://ondeals.today/pages/wormhole-wtk261"
    },
    {
        "category": "sl-tk108b",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81oAmhSSD9L._SL1500.jpg?v=1750061575",
        "name": "Wormhole Tattoo Machine Kit",
        "description": "20 Cartridge Needles Rotary Tattoo Machine Kit Complete Tattoo Gun Kit 10 Tatttoo Ink for Beginners & Tattoo Artist",
        "price": 33.99,
        "originalPrice": 40.99,
        "rating": 4.4,
        "reviewCount": 7061,
        "discountType": "$7 off",
        "link": "https://ondeals.today/pages/wormhole-sl-tk108b"
    },
    {
        "category": "cn-pt3-1207rl",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/61SJm5u0arL._SL1500.jpg?v=1750062112",
        "name": "Wormhole Tattoo Cartridge Needles",
        "description": "7RL Needle Cartridge #12 Standard 7 Round Liner Tattoo Needles 20PCS Disposable Finger Ledge Cartridges 7MM Taper for Tattoo Gun Tattoo Machine Tattoo Supplies 1207RL",
        "price": 11.99,
        "originalPrice": 20.99,
        "rating": 4.3,
        "reviewCount": 47,
        "discountType": "$9 off",
        "link": "https://ondeals.today/pages/wormhole-cn-pt3-1207rl"
    },
    {
        "category": "wtk212",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/81ScRdnGgKL._SL1500.jpg?v=1750062706",
        "name": "Tattoo Gun Kit",
        "description": "Wormhole Tattoo Kit Complete Tattoo Machine Kit Rotary Tattoo Machine Kit 20 Tattoo Needles 5 Tattoo Ink 40 Tattoo Ink Caps for Beginner and Tattoo Artist WTK212",
        "price": 43.29,
        "originalPrice": 47.29,
        "rating": 4.3,
        "reviewCount": 2943,
        "discountType": "$4 off",
        "link": "https://ondeals.today/pages/wormhole-wtk212"
    },
    {
        "category": "wtk086",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/814RjcH8iLL._SL1500.jpg?v=1750063509",
        "name": "Tattoo Gun Kit",
        "description": "Wormhole Tattoo Pen Kit Complete Tattoo Kit Rotary Tattoo Machine Kit with 20pcs Tattoo Cartridge Needles, 10pcs Tattoo Inks Tattoo Gun Kit Beginner WTK086",
        "price": 33.99,
        "originalPrice": 40.99,
        "rating": 4.3,
        "reviewCount": 2943,
        "discountType": "$7 off",
        "link": "https://ondeals.today/pages/wtk086"
    },
    {
        "category": "chkp13-a",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/61cwigOaVWL._SL1500.jpg?v=1750064062",
        "name": "Tattoo Gun BOOTES",
        "description": "Wireless Tattoo Machine Multi-function Tattoo Pen with Replacement Power Supply, Smart Display, Coreless Motor, 7 Strokes Length for Tattoo Artists CHKP13-A",
        "price": 63.99,
        "originalPrice": 85.99,
        "rating": 4.2,
        "reviewCount": 53,
        "discountType": "25% off",
        "discountCode": "ZCJRZWCD",
        "link": "https://ondeals.today/pages/wormholepro-chkp13-a"
    },
    {
        "category": "hkp13-a",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/51U2_NmmYYL._SL1500.jpg?v=1750064516",
        "name": "7 Adjustable Strokes Multi-function",
        "description": "Wireless Tattoo Gun Tattoo Machine Tattoo Pen with Smart Display, Coreless Motor, for Tattoo Artists BOOTES HKP13-A",
        "price": 48.99,
        "originalPrice": 75.99,
        "rating": 4.2,
        "reviewCount": 53,
        "discountType": "25% off",
        "discountCode": "SEOBYE4C",
        "link": "https://ondeals.today/pages/wormhole-hkp13-a"
    },
    {
        "category": "wtk299",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/10.jpg?v=1750065166",
        "name": "Tattoo Gun Adjustable Tattoo Pen Stroke",
        "description": "Tattoo Kit with Dotwork Mode, Memory Function, Professional Grade Tool Suitable for Beginners and Professional Tattoo Artists - Black",
        "price": 54.99,
        "originalPrice": 85.99,
        "rating": 4.7,
        "reviewCount": 30,
        "discountType": "35% off",
        "discountCode": "KFRRBTV5",
        "link": "https://ondeals.today/pages/wormhole-wtk299"
    },
    {
        "category": "wtk309",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71z_4LuNleL._SL1500.jpg?v=1750065566",
        "name": "Aluminum Alloy Tattoo Gun with Adjustable",
        "description": "Tattoo Pen Stroke, Tattoo Kit with Dotwork Mode, Memory Function, Complete Beginners Kit and Professional Tattoo Artists - Compact/Lightweight",
        "price": 55.99,
        "originalPrice": 99.99,
        "rating": 4.7,
        "reviewCount": 30,
        "discountType": "44% off",
        "discountCode": "WUIJIHG9",
        "link": "https://ondeals.today/pages/wormhole-wtk309"
    },
    {
        "category": "1203rllt-20",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71pqWHspVfL._SL1500.jpg?v=1750468121",
        "name": "Wormhole Pro Tattoo Cartridge",
        "description": "Needles 20pcs Disposable Tattoo Needles 3RL Round Liner with Membrane Cartridges Tattoo Supplies for Tattoo Gun Permanent Makeup(1203RLLT)",
        "price": 13.59,
        "originalPrice": 16.99,
        "rating": 5.0,
        "reviewCount": 30,
        "discountType": "20% off",
        "discountCode": "4ZPT53XF",
        "link": "https://ondeals.today/pages/wormhole-1203rllt-20"
    },
    {
        "category": "n201035a-us",
        "image": "https://cdn.shopify.com/s/files/1/0939/8029/5457/files/71tSjVpZ7_L._AC_SL1500.jpg?v=1750663280",
        "name": "Ytonet Gym Backpack for Men Women",
        "description": "Gym Bag for Women with Shoe Compartment Large Water Resistant Lightweight Sport Backpack Fit 15.6 Inch Laptop, Sport, Workout, Travel, Black",
        "price": 21.99,
        "originalPrice": 24.99,
        "rating": 5.0,
        "reviewCount": 30,
        "discountType": "12% off",
        "link": "https://ondeals.today/pages/n201035a-us"
    },
  
]   
// 可选：添加类型注释以提高代码可读性
/**
 * 纹身产品数据结构
 * @typedef {Object} TattooProduct
 * @property {string} category - 产品类别
 * @property {string} image - 产品图片URL
 * @property {string} name - 产品名称
 * @property {string} description - 产品描述
 * @property {number} price - 当前价格
 * @property {number} originalPrice - 原价
 * @property {number} rating - 评分
 * @property {number} reviewCount - 评论数量
 * @property {string} discountType - 折扣类型
 * @property {string} [discountCode] - 折扣码（可选）
 * @property {string} link - 产品链接
 */

/** @type {TattooProduct[]} */
window.allTattooProducts;